import {useContext} from 'react'
import {Container} from './components/Container'
import {CurrentLanguage} from './components/CurrentLanguage'
import {KeyboardArrowDown} from '@material-ui/icons'
import {Languages} from './components/Languages'
import {Language} from './components/Language'
import {CustomLanding36252Context} from '../../../../reducer'
import {CustomLanding36252ActionType} from '../../../../types'
import {t} from '../../../../i18n'

export const LanguageSelector = (): React.ReactElement => {
  const [state, dispatch] = useContext(CustomLanding36252Context)

  const handleClick = () => {
    dispatch?.({
      type: CustomLanding36252ActionType.OpenLanguageSelector,
    })
  }

  return (
    <Container>
      <CurrentLanguage onClick={handleClick}>
        {t[state.language].langName}
        <KeyboardArrowDown />
      </CurrentLanguage>
      {state.languageSelectorOpen && (
        <Languages>
          <Language code="en" />
          <Language code="ar" />
        </Languages>
      )}
    </Container>
  )
}
